var map = {
	"./sba.dark.blue.scss": [
		1345,
		345
	],
	"./sba.dark.green.scss": [
		260,
		260
	],
	"./sba.dark.orange.scss": [
		151,
		151
	],
	"./sba.dark.purple.scss": [
		1175,
		175
	],
	"./sba.dark.red.scss": [
		5716,
		716
	],
	"./sba.light.blue.scss": [
		2171,
		171
	],
	"./sba.light.green.scss": [
		330,
		330
	],
	"./sba.light.orange.scss": [
		9125,
		125
	],
	"./sba.light.purple.scss": [
		4841,
		841
	],
	"./sba.light.red.scss": [
		1354,
		354
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1442;
module.exports = webpackAsyncContext;